import axios from "axios";
import React, { createContext, useContext, useReducer } from "react";

import { Product } from "../reducers/ProductsReducer";
import RecommendationReducer, {
  Recommendation,
} from "../reducers/RecommendationReducer";
import { RecActionType } from "../utils/actions";
import { API_URL, Endpoints } from "../utils/constants";

interface RecommendationResponse {
  result: Recommendation[];
}

const initialState = {
  styleRecsLoading: false,
  styleRecsError: false,
  styleRecommendations: [] as Product[][],
};

const RecommendationContext = createContext({
  styleRecsLoading: false,
  styleRecsError: false,
  styleRecommendations: [] as Product[][],
  getStyleRecommendation: (ids: number[]) => {},
});

export const RecommendationProvider = (props: any) => {
  const { children } = props;
  const [state, dispatch] = useReducer(RecommendationReducer, initialState);

  const getStyleRecommendation = async (ids: number[]) => {
    dispatch({ type: RecActionType.GetStyleRecommendationBegin });
    try {
      //const response = await axios.get<RecommendationResponse>(
      //  `${API_URL}${Endpoints.Recommendation}`,
      //  { params: { products: ids } }
      //);
      const response = await axios.get<RecommendationResponse>(
          `${API_URL}${Endpoints.Recommendation}?${ids.map((id) => `products=${id}`).join('&')}`
      );

      const recommendations = response.data;
      const outfits = recommendations.result.map((rec, index) => rec.metadata);
      dispatch({
        type: RecActionType.GetStyleRecommendationSuccess,
        payload: outfits,
      });
      return recommendations.result;
    } catch (error) {
      dispatch({ type: RecActionType.GetStyleRecommendationError });
    }
  };

  const contextValues = {
    ...state,
    getStyleRecommendation,
  };

  return (
    <RecommendationContext.Provider value={contextValues}>
      {children}
    </RecommendationContext.Provider>
  );
};

export const useRecommendationContext = () => {
  return useContext(RecommendationContext);
};
